export enum PoiGroupType {
  FERRYBOAT = 'FERRYBOAT',
  TRAIN = 'TRAIN',
  SERVICE = 'SERVICE',
  WASH = 'WASH',
  PARKING = 'PARKING',
  FUEL_STATION = 'FUEL_STATION',
  CMR_POST = 'CMR_POST',
  PALLETS_POST = 'PALLETS_POST',
  OTHER = 'OTHER'
}
